<div class="generic-modal-root">
  <ngx-spinner
    bdColor="rgba(75, 55, 100, 0.5)"
    size="large"
    color="#fff"
    type="line-scale-pulse-out">
        <span class="chevron left"></span>
        <span class="chevron right"></span>
  </ngx-spinner>

  <div class="row-padding">
    <div class="row">
      <form
        style="width: 100%"
        *ngIf="form"
        [formGroup]="form"
        class="m-form m-form--fit m-form--label-align-right"
      >

        <div class="form-group move-left m-form__group row remove-margin">
          <label class="col-lg-4 col-form-label"> Name </label>
          <div class="col-lg-8">
            <input
              type="text"
              class="form-control m-input"
              formControlName="name"
            />
            <app-validation-display
              [control]="form.controls.name"
              errorMessage="Please enter a valid name. Config name must not contain the ''/'' character or any whitespace characters"
              >
            </app-validation-display>
          </div>
        </div>
        <div class="form-group move-left m-form__group row remove-margin">
          <label class="col-lg-4 col-form-label"> Object Path </label>
          <div class="col-lg-8">
            <input
              type="text"
              class="form-control m-input"
              formControlName="path"
            />
          </div>
        </div>
        <div class="form-group move-left m-form__group row remove-margin">
          <label class="col-lg-4 col-form-label"> Bucket Name </label>
          <div class="col-lg-8">
            <input
              type="text"
              class="form-control m-input"
              formControlName="bucketName"
            />
          </div>
        </div>
        <div class="form-group move-left m-form__group row remove-margin">
          <label class="col-lg-4 col-form-label"> Config </label>
          <div class="col-lg-8">
            <textarea
              rows="12"
              type="text"
              class="form-control m-input"
              formControlName="value"
            ></textarea>
          </div>
        </div>
        <div class="form-group move-left m-form__group row remove-margin">
          <label class="col-lg-4 col-form-label"> </label>
          <div class="col-lg-8">
            <span style="color:red" *ngIf="form.invalid && form.dirty" class="m-form__help" >
              One or more fields are missing or invalid
            </span><br>
          </div>
        </div>
      </form>
      <div style="height: 45px; padding-left: 600px;">
        
        <button
          (click)="close()"
          class="btn btn-success"
          style="margin:10px; float:right"
        >
          Cancel
        </button>
        <button
          (click)="saveAndClose()"
          class="btn btn-success"
          style="margin-top:10px; float:right"
        >
          Save
        </button>
      </div>
    </div>
  </div>
</div>
